import none from '../../img/kandokLogo.jpg'
export const deser =[
 {
  "id": 41,
  "title": "زیتون پرورده",
  "price": 60,
  "image": none
 },
 {
  "id": 42,
  "title": "سالاد فصل",
  "price": 50,
  "image": none
 },
 {
  "id": 43,
  "title": "ماست موسیر محلی",
  "price": 50,
  "image": none
 },
 {
  "id": 44,
  "title": "ساالد شیرازی",
  "price": 50,
  "image": none
 }
]